import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from './../../shared/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs } from 'file-saver';
import { FormBuilder, FormControl, FormGroup , Validators} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { UserService } from './../../@core/data/users.service';
import { ConfirmationService } from 'primeng/api';



@Component({
  selector: 'educational',
  template: `
  <style>
  .mat-form-field--inline {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .mat-form-field--inline .mat-form-field {
        display: inline-block;
        width: 100%;
        vertical-align: middle;
    }

    .mat-form-field--inline .mat-form-field:nth-child(1) {
        margin-right: 10px;
    }
    
    @media (max-width: 767px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 1200px) {
      #selectLine{  
        width: 145%;
      } 
    }
      
    @media (min-width: 768px) {
      #selectLine{  
        width: 65%;
      } 
    }
      
    @media (min-width: 992px) {
      #selectLine{  
        width: 145%;
      } 
    }

    .example-full-width {
      
    }
  </style>
  <nb-card status="success"  [style.height.px]="630" [style.overflow]="'auto'">
    <nb-card-header>Add Educational Details</nb-card-header>
    <nb-card-body> 
      <span *ngIf="instructionValidation===false" style="color:red;">Please add medium of instruction which is below subjects.</span>
      <form [formGroup]="edu_form"  class="step-container">
        <div class="row">
          <div class="col-md-3">Course Name : </div>
          <div class="col-md-2"> 
            <!--<input  ngModel="{{edu_data?.CourseName}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.courseNameCtrl.invalid && (edu_form.controls.courseNameCtrl.dirty || edu_form.controls.courseNameCtrl.touched)}" formControlName="courseNameCtrl" placeholder="" id="" class="form-control">-->
            <mat-form-field  id="selectLine">
              <mat-select ngModel="{{course_name}}" name="coursename" formControlName="courseNameCtrl" disabled>
                  <mat-option value="{{course.CourseShortForm}}" *ngFor="let course of course_data">{{course.CourseName}}</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="courseValidation===false" style="color:red;">Please select College Year.</span>  
          </div>
          
          

          <!--<div class="col-md-3" style="padding-left: 9%;" >Course : </div>
          <div class="col-md-2" style="padding-left: 5%;">
            <mat-form-field id="selectLine" >
              <mat-select ngModel="{{edu_data?.total_weeks}}" name="clgCourse" formControlName="clgCourseCtrl">
                  <mat-option value="Retail Management">Retail Management</mat-option>
                  <mat-option value="Tourism & Hospitality Management">Tourism & Hospitality Management</mat-option>
              </mat-select>
            </mat-form-field>
           
          </div>-->

          <div class="col-md-3"  style="padding-left: 9%;" *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'" >
                Specialization in(subject) : </div>
              <div class="col-md-2" style="padding-left: 5%;" >
                <mat-form-field id="selectLine" *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'"> 
                  <mat-select  ngModel="{{specialisation_name}}"  name="specialisationname" formControlName="SpecialisationCtrl" disabled>
                      <mat-option value="{{specialisation.specialisation_name}}" *ngFor="let specialisation of specialisation_data">{{specialisation.specialisation_name}}</mat-option>
                  </mat-select>
                </mat-form-field>
               </div>
       
        </div>
        <div class="row">
          <div class="col-md-3">College Year : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select ngModel="{{college_year}}" name="collegeYear" formControlName="collegeYearCtrl" disabled>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'" value="First">First</mat-option>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Master' || edu_level == 'Bachelor'" value="Second">Second</mat-option>
              <mat-option *ngIf="edu_level == 'Degree' || edu_level == 'Bachelor'" value="Third">Third</mat-option>
                  <!-- <mat-option value="Fourth">Fourth</mat-option> -->
              </mat-select>
            </mat-form-field>
            <span *ngIf="collegeYearValidation===false" style="color:red;">Please select College Year.</span> 
          </div>
          <div class="col-md-3" style="padding-left: 9%;">Semester : </div>
          <div class="col-md-2" style="padding-left: 5%;">
              <mat-form-field id="selectLine" >
                  <mat-select ngModel="{{semester_auto}}" name="semester" formControlName="semesterCtrl">
                   <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='First'" value="I">I</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='First'" value="II">II</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Second'" value="III">III</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Second'" value="IV">IV</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'" value="V">V</mat-option>
                  <mat-option *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'" value="VI">VI</mat-option>
                   <!--   <mat-option value="VII">VII</mat-option>
                      <mat-option value="VIII">VIII</mat-option> -->
                  </mat-select>
              </mat-form-field>
              <span *ngIf="semesterValidation===false" style="color:red;">Please select semester</span> 
          </div>
      </div>
      <div class="row">
          <div class="col-md-3">Month : </div>
          <div class="col-md-2">
            <mat-form-field id="selectLine" >
              <mat-select  ngModel="{{edu_data?.Month}}" name="month" formControlName="monthCtrl">
                  <mat-option value="January">January</mat-option>
                  <mat-option value="February">February</mat-option>
                  <mat-option value="March">March</mat-option>
                  <mat-option value="April">April</mat-option>
                  <mat-option value="May">May</mat-option>
                  <mat-option value="June">June</mat-option>
                  <mat-option value="July">July</mat-option>
                  <mat-option value="August">August</mat-option>
                  <mat-option value="September">September</mat-option>
                  <mat-option value="October">October</mat-option>
                  <mat-option value="November">November</mat-option>
                  <mat-option value="December">December</mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="monthValidation===false" style="color:red;">Please select month</span> 
          </div>
            <div class="col-md-3" style="padding-left: 9%;">Year : </div>
          <div class="col-md-2" style="padding-left: 5%;">
              <mat-form-field id="selectLine" >
                  <mat-select ngModel="{{edu_data?.Year}}" name="year" formControlName="yearCtrl">
                      <mat-option value="{{years}}" *ngFor="let years of years_array">{{years}}</mat-option>
                  </mat-select>
              </mat-form-field>
              <span *ngIf="yearValidation===false" style="color:red;">Please select year.</span> 
          </div>
          </div>
          <div class="row">
          <div class="col-md-3" *ngIf="admin_show == 'true'"  >Start Month : </div>
          <div class="col-md-2" *ngIf="admin_show == 'true'">
            <mat-form-field id="selectLine" >
              <mat-select  ngModel="{{edu_data?.endmonth}}" name="month" formControlName="endmonthCtrl">
                  <mat-option value="January">January</mat-option>
                  <mat-option value="February">February</mat-option>
                  <mat-option value="March">March</mat-option>
                  <mat-option value="April">April</mat-option>
                  <mat-option value="May">May</mat-option>
                  <mat-option value="June">June</mat-option>
                  <mat-option value="July">July</mat-option>
                  <mat-option value="August">August</mat-option>
                  <mat-option value="September">September</mat-option>
                  <mat-option value="October">October</mat-option>
                  <mat-option value="November">November</mat-option>
                  <mat-option value="December">December</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <span *ngIf="endmonthValidation===false" style="color:red;">Please select start month</span>  -->
          </div> 
          <div class="col-md-3" *ngIf="admin_show == 'true'" style="padding-left: 9%;">Start Year : </div>
          <div class="col-md-2"  *ngIf="admin_show == 'true'" style="padding-left: 5%;">
              <mat-form-field id="selectLine" >
              <mat-select ngModel="{{edu_data?.startYear}}" name="year" formControlName="startyearCtrl">
              <mat-option value="{{years}}" *ngFor="let years of enrollYear">{{years}}</mat-option>
                  </mat-select>
              </mat-form-field> 
          </div>
         </div>
      <marquee *ngIf="admin_show == 'false'"><u><b style="color:red; font-size: 100%;">If you don't find your subject code or subject name under the drop down list, kindly do not select an incorrect option instead connect with our support team.</b></u></marquee>
      <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-3">Subject Name</div>
      <div class="col-md">Course Credits</div>
      <div class="col-md">TH</div>
      <div class="col-md">IA</div>
      <div class="col-md">Grades Obtained</div>
      <div class="col-md">Credits Earned (C)</div>
      <div class="col-md">Grade points (G)</div>
      <div class="col-md">C * G</div>
      <div class="col-md">Hours & Minutes Per Week</div>
      <div class="col-md">Lectures Per Week</div>
      <div class="col-md">Months &nbsp; taken</div>
    </div>
      <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 1 :</div>
      <div class="col-md-2" >
        <div *ngIf= "edu_data?.Subject_First != null && edu_data?.Subject_First != '' && edu_data?.Subject_First != undefined && showcodeDropdown == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_First" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput2"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college2 of course_code2 | filter: {Course_Subject_name : filterText2}" [value]="college2" (click)="getCourse(college2)">
              {{college2.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown()"></i>
        </div>

        <!-- <textarea  ngModel="{{edu_data?.Subject_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFirstCtrl.invalid && (edu_form.controls.subjectFirstCtrl.dirty || edu_form.controls.subjectFirstCtrl.touched)}" formControlName="subjectFirstCtrl" placeholder="name" id="" class="form-control"></textarea> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_one}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.internalMarksCtrl.invalid && (edu_form.controls.internalMarksCtrl.dirty || edu_form.controls.internalMarksCtrl.touched)}" formControlName="internalMarksCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstCtrl.invalid && (edu_form.controls.markFirstCtrl.dirty || edu_form.controls.markFirstCtrl.touched)}" formControlName="markFirstCtrl" placeholder="Marks Obtained" (change)="myFunc()"  id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue ? totalValue : edu_data?.marks_out_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markFirstOutCtrl.invalid && (edu_form.controls.markFirstOutCtrl.dirty || edu_form.controls.markFirstOutCtrl.touched)}" formControlName="markFirstOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradeFirstCtrl.invalid && (edu_form.controls.gradeFirstCtrl.dirty || edu_form.controls.gradeFirstCtrl.touched)}" formControlName="gradeFirstCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.creditsEarnedCFirstCtrl.invalid && (edu_form.controls.creditsEarnedCFirstCtrl.dirty || edu_form.controls.creditsEarnedCFirstCtrl.touched)}" formControlName="creditsEarnedCFirstCtrl" placeholder="Credits Earned C" (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradepointsFirstCtrl.invalid && (edu_form.controls.gradepointsFirstCtrl.dirty || edu_form.controls.gradepointsFirstCtrl.touched)}" formControlName="gradepointsFirstCtrl"(change)='getTotalCnG()'  placeholder="Grade points G" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G ? C_into_G : edu_data?.grade_credits_First}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradecreditsFirstCtrl.invalid && (edu_form.controls.gradecreditsFirstCtrl.dirty || edu_form.controls.gradecreditsFirstCtrl.touched)}" formControlName="gradecreditsFirstCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_First}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null" formControlName="hoursMinutesPerWeek1Ctrl" placeholder="hours Minutes Per Week 1" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName ? this.subjectName['Lectures_per_Week'] : edu_data?.lecture_hour_First}}" nbInput type="text"   [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl1" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName ? this.subjectName['Months_taken'] :edu_data?.months_taken_First}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl" placeholder="months taken" id="" class="form-control"></div>
         </div>
        <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 2 :</div>
      <div class="col-md-2">
        <div  *ngIf= "showcodeDropdown2 == false">
          <textarea  nbInput disabled   [value]="edu_data?.Subject_Second" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown2 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code | filter: {Course_Subject_name : filterText}" [value]="college" (click)="getCourse2(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

          <div class="row">
            Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
            <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown2()"></i>
          </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectSecondCtrl.invalid && (edu_form.controls.subjectSecondCtrl.dirty || edu_form.controls.subjectSecondCtrl.touched)}" formControlName="subjectSecondCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_two}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.internalMarksSecondCtrl.invalid && (edu_form.controls.internalMarksSecondCtrl.dirty || edu_form.controls.internalMarksSecondCtrl.touched)}" formControlName="internalMarksSecondCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markSecondCtrl.invalid && (edu_form.controls.markSecondCtrl.dirty || edu_form.controls.markSecondCtrl.touched)}" formControlName="markSecondCtrl" placeholder="Marks Obtained" (change)="myFunc()" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue2 ? totalValue2 : edu_data?.marks_out_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markSecondOutCtrl.invalid && (edu_form.controls.markSecondOutCtrl.dirty || edu_form.controls.markSecondOutCtrl.touched)}" formControlName="markSecondOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradeSecondCtrl.invalid && (edu_form.controls.gradeSecondCtrl.dirty || edu_form.controls.gradeSecondCtrl.touched)}" formControlName="gradeSecondCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.markSecondCtrl.invalid && (edu_form.controls.markSecondCtrl.dirty || edu_form.controls.markSecondCtrl.touched)}" formControlName="creditsEarnedCSecondCtrl" placeholder="Credits Earned C"   (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradepointsSecondCtrl.invalid && (edu_form.controls.gradepointsSecondCtrl.dirty || edu_form.controls.gradepointsSecondCtrl.touched)}" formControlName="gradepointsSecondCtrl" (change)='getTotalCnG()' placeholder="Grade points G" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G2 ? C_into_G2 : edu_data?.grade_credits_Second}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.gradecreditsSecondCtrl.invalid && (edu_form.controls.gradecreditsSecondCtrl.dirty || edu_form.controls.gradecreditsSecondCtrl.touched)}" formControlName="gradecreditsSecondCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Second}}" nbInput  [attr.disabled]="isDisabled ? '' : null" type="text" formControlName="hoursMinutesPerWeek1Ctrl2" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : edu_data?.lecture_hour_Second}}" nbInput type="text"   [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl2" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName2 ? this.subjectName2['Months_taken'] :edu_data?.months_taken_Second}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl2" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1  mt-4">Subject 3 :</div>
      <div class="col-md-2" >
        <div *ngIf= "edu_data?.Subject_Third != null && edu_data?.Subject_Third != '' && edu_data?.Subject_Third != undefined && showcodeDropdown3 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Third"style="width: 160%;" nbInput type="text" id="" ></textarea>
          
        </div>

        <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown3 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput3"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code3 | filter: {Course_Subject_name : filterText3}" [value]="college" (click)="getCourse3(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown3()"></i>
        </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Third}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectThirdCtrl.invalid && (edu_form.controls.subjectThirdCtrl.dirty || edu_form.controls.subjectThirdCtrl.touched)}" formControlName="subjectThirdCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_three}}" nbInput type="text" formControlName="internalMarksThirdCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Third}}" nbInput type="text"  formControlName="markThirdCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue3 ? totalValue3 : edu_data?.marks_out_Third}}" nbInput type="text"  formControlName="markThirdOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Third}}" nbInput type="text"  formControlName="gradeThirdCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Third}}" nbInput type="text"  formControlName="creditsEarnedCThirdCtrl" placeholder="Credits Earned C"   (change)='getTotalCredits()'id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Third}}" nbInput type="text"  formControlName="gradepointsThirdCtrl" (change)='getTotalCnG()' placeholder="Grade points G" id="" class="form-control"></div>
        <div class="col-md"><input  style = 'width: 80% !important; ' ngModel="{{C_into_G3 ? C_into_G3 : edu_data?.grade_credits_Third}}" nbInput type="text"  formControlName="gradecreditsThirdCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '   ngModel="{{this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Third}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null"  formControlName="hoursMinutesPerWeek1Ctrl3" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : edu_data?.lecture_hour_Third}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl3" placeholder="lectures Per Week" id="" class="form-control"></div>
      <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName3 ? this.subjectName3['Months_taken'] :edu_data?.months_taken_Third}}" nbInput type="text"  [attr.disabled]="isDisabled ? '' : null"  formControlName="monthstakenCtrl3" placeholder="Grade" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1  mt-4">Subject 4 :</div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Fourth != null && edu_data?.Subject_Fourth != '' && edu_data?.Subject_Fourth != undefined && showcodeDropdown4 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Fourth" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown4 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput4"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code4 | filter: {Course_Subject_name : filterText4}" [value]="college" (click)="getCourse4(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown4()"></i>
        </div> 
        <!-- <textarea  ngModel="{{edu_data?.Subject_Fourth}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.subjectFourthCtrl.invalid && (edu_form.controls.subjectFourthCtrl.dirty || edu_form.controls.subjectFourthCtrl.touched)}" formControlName="subjectFourthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_four}}" nbInput type="text" formControlName="internalMarksFourthCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Fourth}}" nbInput type="text"  formControlName="markFourthCtrl" placeholder="Marks Obtained" (change)="myFunc()" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue4 ? totalValue4 : edu_data?.marks_out_Fourth}}" nbInput type="text"  formControlName="markFourthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Fourth}}" nbInput type="text" formControlName="gradeFourthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Fourth}}" nbInput type="text" formControlName="creditsEarnedCFourthCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()'  id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Fourth}}" nbInput type="text" formControlName="gradepointsFourthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G4 ? C_into_G4 : edu_data?.grade_credits_Fourth}}" nbInput type="text" formControlName="gradecreditsFourthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week'] : edu_data?.practical_hour_Fourth}}" nbInput  [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl4" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : edu_data?.lecture_hour_Fourth}}" nbInput  [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="lecturesPerWeekCtrl4" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName4 ? this.subjectName4['Months_taken'] :edu_data?.months_taken_Fourth}}" nbInput  [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="monthstakenCtrl4" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1  mt-4">Subject 5 :</div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Fifth != null && edu_data?.Subject_Fifth != '' && edu_data?.Subject_Fifth != undefined && showcodeDropdown5 == false">
          <textarea nbInput  disabled   [value]="edu_data?.Subject_Fifth" style="width: 160%;"nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown5 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput5"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code5 | filter: {Course_Subject_name : filterText5}" [value]="college" (click)="getCourse5(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown5()"></i>
        </div>

        <!-- <textarea  ngModel="{{edu_data?.Subject_Fifth}}" nbInput type="text"  formControlName="subjectFifthCtrl" placeholder="name" id="" class="form-control"></textarea> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_five}}" nbInput type="text" formControlName="internalMarksFifthCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Fifth}}" nbInput type="text" formControlName="markFifthCtrl" placeholder="Marks Obtained" (change)="myFunc()" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue5 ? totalValue5 : edu_data?.marks_out_Fifth}}" nbInput type="text" formControlName="markFifthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Fifth}}" nbInput type="text" formControlName="gradeFifthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Fifth}}" nbInput type="text" formControlName="creditsEarnedCFifthCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Fifth}}" nbInput type="text" formControlName="gradepointsFifthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G5 ? C_into_G5 : edu_data?.grade_credits_Fifth}}" nbInput type="text" formControlName="gradecreditsFifthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Fifth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl5" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
      <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : edu_data?.lecture_hour_Fifth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="lecturesPerWeekCtrl5" placeholder="lectures Per Week" id="" class="form-control"></div>
      <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName5 ? this.subjectName5['Months_taken'] :edu_data?.months_taken_Fifth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null"  formControlName="monthstakenCtrl5" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1  mt-4">Subject 6 :</div>
      <div class="col-md-2" >
        <div *ngIf= "edu_data?.Subject_Six != null && edu_data?.Subject_Six != '' && edu_data?.Subject_Six != undefined && showcodeDropdown6 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Six" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown6 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput6"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code6 | filter: {Course_Subject_name : filterText6}" [value]="college" (click)="getCourse6(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown6()"></i>
        </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Six}}" nbInput type="text"  formControlName="subjectSixthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_six}}" nbInput type="text" formControlName="internalMarksSixthCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Six}}" nbInput type="text" formControlName="markSixthCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue6 ? totalValue6 : edu_data?.marks_out_Six}}" nbInput type="text" formControlName="markSixthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Six}}" nbInput type="text" formControlName="gradeSixthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Sixth}}" nbInput type="text" formControlName="creditsEarnedCSixthCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Six}}" nbInput type="text" formControlName="gradepointsSixthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G6 ? C_into_G6 : edu_data?.grade_credits_Six}}" nbInput type="text" formControlName="gradecreditsSixthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '   ngModel="{{this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Six}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl6" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '   ngModel="{{this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : edu_data?.lecture_hour_Six}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl6" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName6 ? this.subjectName6['Months_taken'] :edu_data?.months_taken_Six}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl6" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 7 :</div>
      <div class="col-md-2" >
        <div *ngIf= "edu_data?.Subject_Seventh != null && edu_data?.Subject_Seventh != '' && edu_data?.Subject_Seventh != undefined && showcodeDropdown7 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Seventh" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData"style="width: 160%;" *ngIf = "showcodeDropdown7 == true">
          <mat-select placeholder="Course Code" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput7"   [placeholderLabel]="'Subjects...'"  >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code7 | filter: {Course_Subject_name : filterText7}" [value]="college" (click)="getCourse7(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown7()"></i>
        </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Seventh}}" nbInput type="text"  formControlName="subjectSeventhCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_seven}}" nbInput type="text" formControlName="internalMarksSeventhCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Seventh}}" nbInput type="text" formControlName="markSeventhCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue7 ? totalValue7 : edu_data?.marks_out_Seventh}}" nbInput type="text" formControlName="markSeventhOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Seventh}}" nbInput type="text" formControlName="gradeSeventhCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Seven}}" nbInput type="text" formControlName="creditsEarnedCSevenCtrl" placeholder="Credits Earned C"   (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Seventh}}" nbInput type="text" formControlName="gradepointsSeventhCtrl" placeholder="Grade points G"  (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G7 ? C_into_G7 : edu_data?.grade_credits_Seventh}}" nbInput type="text" formControlName="gradecreditsSeventhCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Seventh}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl7" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : edu_data?.lecture_hour_Seventh}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl7" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{this.subjectName7 ? this.subjectName7['Months_taken'] :edu_data?.months_taken_Seventh}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl7" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 8 :</div>
      <div class="col-md-2">
        <div  *ngIf= "edu_data?.Subject_Eighth != null && edu_data?.Subject_Eighth != '' && edu_data?.Subject_Eighth != undefined && showcodeDropdown8 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Eighth" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown8 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput8"    [placeholderLabel]="'Subjects...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code8 | filter: {Course_Subject_name : filterText8}" [value]="college" (click)="getCourse8(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown8()"></i>
        </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Eighth}}" nbInput type="text"  formControlName="subjectEighthCtrl" placeholder="name" id="" class="form-control"></textarea> --> 
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.internal_Marks_eight}}" nbInput type="text" formControlName="internalMarksEightCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Eighth}}" nbInput type="text" formControlName="markEighthCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue8 ? totalValue8 : edu_data?.marks_out_Eighth}}" nbInput type="text" formControlName="markEighthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Eighth}}" nbInput type="text" formControlName="gradeEighthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Eight}}" nbInput type="text" formControlName="creditsEarnedCEightCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Eighth}}" nbInput type="text" formControlName="gradepointsEighthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G8 ? C_into_G8 :  edu_data?.grade_credits_Eighth}}" nbInput type="text" formControlName="gradecreditsEighthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Eighth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl8" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : edu_data?.lecture_hour_Eighth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl8" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName8 ? this.subjectName8['Months_taken'] :edu_data?.months_taken_Eighth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl8" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 9 :</div>
      <div class="col-md-2" >
        <div  *ngIf= "edu_data?.Subject_Ninth != null && edu_data?.Subject_Ninth != '' && edu_data?.Subject_Ninth != undefined && showcodeDropdown9 == false">
          <textarea nbInput disabled   [value]="edu_data?.Subject_Ninth" style="width: 160%;" nbInput type="text" id="" ></textarea>
         
        </div>

        <mat-form-field appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown9 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput9"    [placeholderLabel]="'Subjects...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code9 | filter: {Course_Subject_name : filterText9}" [value]="college" (click)="getCourse9(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown9()"></i>
        </div>
        <!-- <textarea  ngModel="{{edu_data?.Subject_Ninth}}" nbInput type="text"  formControlName="subjectNinthCtrl" placeholder="name" id="" class="form-control"></textarea> -->
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '   ngModel="{{edu_data?.internal_Marks_nine}}" nbInput type="text" formControlName="internalMarksNineCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Ninth}}" nbInput type="text" formControlName="markNinthCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue9 ? totalValue9 : edu_data?.marks_out_Ninth}}" nbInput type="text" formControlName="markNinthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Ninth}}" nbInput type="text" formControlName="gradeNinthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_Ninth}}" nbInput type="text" formControlName="creditsEarnedCNinthCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Ninth}}" nbInput type="text" formControlName="gradepointsNinthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G9 ? C_into_G9 :   edu_data?.grade_credits_Ninth}}" nbInput type="text" formControlName="gradecreditsNinthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName9 ? this.subjectName9['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Ninth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl9" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName9 ? this.subjectName9['Lectures_per_Week'] : edu_data?.lecture_hour_Ninth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl9" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName9 ? this.subjectName9['Months_taken'] :edu_data?.months_taken_ninth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl9" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-1 mt-4">Subject 10 :</div>
      <div class="col-md-2">
        <div *ngIf= "edu_data?.Subject_Tenth != null && edu_data?.Subject_Tenth != '' && edu_data?.Subject_Tenth != undefined && showcodeDropdown10 == false">
          <input  disabled   [value]="edu_data?.Subject_Tenth" style="width: 160%;" nbInput type="text" id="" >
          
        </div>

        <mat-form-field  appearance="outline" [formGroup]="formData" style="width: 160%;" *ngIf = "showcodeDropdown10 == true">
          <mat-select placeholder="Subject" style="width: 140%;"   #singleSelect2 >
            <mat-option >
              <ngx-mat-select-search [formControl]="filterInput10"    [placeholderLabel]="'Subjects...'" >
                <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              </ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let college of course_code10 | filter: {Course_Subject_name : filterText10}" [value]="college" (click)="getCourse10(college)">
              {{college.Course_Subject_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="row">
          Can't Find ? &nbsp; <i class="fas fa-phone-square fa-lg" title="Contact" style="color: green;" (click)= "showContactDetails()"></i>
          <i class="fas fa-pen-alt fa-lg" (click)="showcoursecodeDropdown10()"></i>
        </div>
      </div>
      &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div class="col-md"><input style = 'width: 80% !important; '   ngModel="{{edu_data?.internal_Marks_ten}}" nbInput type="text" formControlName="internalMarksTenCtrl" placeholder="Internal Marks" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.marks_obt_Tenth}}" nbInput type="text" formControlName="markTenthCtrl" placeholder="Marks Obtained" id="" (change)="myFunc()" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{totalValue10 ? totalValue10 : edu_data?.marks_out_Tenth}}" nbInput type="text" formControlName="markTenthOutCtrl" placeholder="Total" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_Tenth}}" nbInput type="text" formControlName="gradeTenthCtrl" placeholder="Grade" id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.credits_Earned_c_ten}}" nbInput type="text" formControlName="creditsEarnedCtehthCtrl" placeholder="Credits Earned C"  (change)='getTotalCredits()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{edu_data?.grade_points_Tenth}}" nbInput type="text" formControlName="gradepointsTenthCtrl" placeholder="Grade points G" (change)='getTotalCnG()' id="" class="form-control"></div>
        <div class="col-md"><input style = 'width: 80% !important; '  ngModel="{{C_into_G10 ? C_into_G10 :edu_data?.grade_credits_Tenth}}" nbInput type="text" formControlName="gradecreditsTenthCtrl" placeholder="C * G" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName10 ? this.subjectName10['Hours_and_Minutes_per_Week']  : edu_data?.practical_hour_Tenth}}" nbInput [attr.disabled]="isDisabled ? '' : null" type="text"  formControlName="hoursMinutesPerWeek1Ctrl10" placeholder="hours Minutes Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName10 ? this.subjectName10['Lectures_per_Week'] : edu_data?.lecture_hour_Tenth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="lecturesPerWeekCtrl10" placeholder="lectures Per Week" id="" class="form-control"></div>
        <div class="col-md" ><input style = 'width: 80% !important; '  ngModel="{{this.subjectName10 ? this.subjectName10['Months_taken'] :edu_data?.months_taken_tenth}}" nbInput type="text" [attr.disabled]="isDisabled ? '' : null" formControlName="monthstakenCtrl10" placeholder="months taken" id="" class="form-control"></div>
      </div>
      <br>

      <div class="row">
          <div class="col-md-2">Total Credits Points: </div>
          <div class="col-md-2">
            <input  ngModel="{{creditTotal ? creditTotal : edu_data?.total_credits_Earned_C}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.totalCCtrl.invalid && (edu_form.controls.totalCCtrl.dirty || edu_form.controls.totalCCtrl.touched)}" formControlName="totalCCtrl" placeholder="Total C" id="" class="form-control"> 
          </div>
          <div class="col-md-2">Total of C * G  : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalCnG ? totalCnG : edu_data?.total_CnG}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.totalCnGCtrl.invalid && (edu_form.controls.totalCnGCtrl.dirty || edu_form.controls.totalCnGCtrl.touched)}" formControlName="totalCnGCtrl" placeholder="Total (C*G)" id="" class="form-control"> 
          </div>
      </div>
      <br>
      <div class="row">
      <div class="col-md-2">Total Marks Obtain:</div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.overall_marks_obt}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksobtCtrl.invalid && (edu_form.controls.overmarksobtCtrl.dirty || edu_form.controls.overmarksobtCtrl.touched)}" formControlName="overmarksobtCtrl" placeholder="Total Marks" id="" class="form-control"> </div>
        <div class="col-md-2">Out Of:</div>
        <div class="col-md-2"><input  ngModel="{{edu_data?.overall_marks_out}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overmarksoutCtrl.invalid && (edu_form.controls.overmarksoutCtrl.dirty || edu_form.controls.overmarksoutCtrl.touched)}" formControlName="overmarksoutCtrl" placeholder="Out of" id="" class="form-control"> </div>
      </div>

      <br>

      <div class="row">
          <div class="col-md-2">Over All Grade : </div>
          <div class="col-md-2">
            <input  ngModel="{{edu_data?.OverAllGrade}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overAllGradeCtrl.invalid && (edu_form.controls.overAllGradeCtrl.dirty || edu_form.controls.overAllGradeCtrl.touched)}" formControlName="overAllGradeCtrl" placeholder="" id="" class="form-control"> 
          </div>
          <div class="col-md-2">GPA : </div>
          <div class="col-md-2">
            <input  ngModel="{{totalcgpa ? totalcgpa : edu_data?.overall_gpa_sgpi}}" nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.overAllgpasgpiCtrl.invalid && (edu_form.controls.overAllgpasgpiCtrl.dirty || edu_form.controls.overAllgpasgpiCtrl.touched)}" formControlName="overAllgpasgpiCtrl" placeholder="" id="" class="form-control"> 
          </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2" *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'">OVERALL CGPA(IST TO VITH SEMESTERS) : </div>
        <div class="col-md-2" *ngIf="edu_form.controls['collegeYearCtrl'].value==='Third'"> <input  ngModel="{{edu_data?.overall_CGPA}}" nbInput type="text"  formControlName="OverallCGPACtrl" placeholder="OVERALL CGPA" id="" class="form-control"> </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'">FINAL GRADE : </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.overAllYearlyGrade}}" nbInput type="text" formControlName="finalGradeCtrl" placeholder="" id="" class="form-control"> </div>
      </div>
      <br>
      <div class="row" >
        <div class="col-md-2">Medium of instruction : </div>
        <div class="col-md-2"> <input  [ngModel]="edu_data ? edu_data?.medium_instruction : 'English' "  nbInput type="text" [ngClass]="{'form-control-danger': edu_form.controls.instructionCtrl.invalid && (edu_form.controls.instructionCtrl.dirty || edu_form.controls.instructionCtrl.touched)}" formControlName="instructionCtrl" placeholder="" id="" class="form-control"> </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'">Special Instruction : </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.special_instruction}}" nbInput type="text" formControlName="specialInstrctionCtrl" placeholder="" id="" class="form-control"> </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-2" *ngIf="admin_show == 'true'">Final Grade Special Instruction : </div>
        <div class="col-md-2" *ngIf="admin_show == 'true'"><input  ngModel="{{edu_data?.final_grade_special_instruction}}" nbInput type="text" formControlName="finalgradespecialInstrctionCtrl" placeholder="" id="" class="form-control"> </div>
      </div>
      </form>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton hero status="primary" (click)="dismiss()">Close</button> 
        <button *ngIf="amount_paid == 'false'" nbButton status="info" (click)="saveEdu()">save</button>
    </nb-card-footer>
</nb-card>
`,
providers: [ ConfirmationService]
})
export class addEducationalDetailsSemesterBVOCGPA implements OnInit {
  FeedbackForm : FormGroup;
  @Input() user_id: any;
  @Input() edu_id: any;
  @Input() course_name_auto : String;
  @Input() college_year_auto : String;
  // @Input() specialisationShow:any;
  // @Input() bvocShowSub:any;
  @Input() amount_paid:string;
  @Input() admin_show:string;
  @Input() enrollment_year_auto: number;
  @Input() specialisationlevel_auto: string;
  specialisationShow = 'True'
 
  validations_flag = false;
  feedback_message ;
  //showExperience = false;

  edu_form: FormGroup;
  years_array;
  specialisation_data;
  specialisation_name: any;
  courseValidation = true;
  collegeYearValidation = true;
  semesterValidation  = true;
  monthValidation  = true;
  yearValidation = true;
  attemptValidation  = true;
  instructionValidation = true;
  endmonthValidation = true;
  endYearValidation = true;
  edu_data;
  course_data;
  user: any;
  totalMarks: number;
  totalMarksOut: number;
  creditTotal: number;
  totalCnG : number;
  totalcgpa: number;

  totalValue: number;
  totalValue2: number;
  totalValue3: number;
  totalValue4: number;
  totalValue5: number;
  totalValue6: number;
  totalValue7: number;
  totalValue8: number;
  totalValue9: number;
  totalValue10: number;

  hourValue: any;
  hourValue8: any;
  hourValue7: any;
  hourValue6: any;
  hourValue5: any;
  hourValue4: any;
  hourValue3: any;
  hourValue2: any;
  lecVal1: any;
  lecVal2: any;
  lecVal3: any;
  lecVal4: any;
  lecVal5: any;
  lecVal6: any;
  lecVal7: any;
  lecVal8: any;
  monthTaken2: any;
  monthTaken1: any;
  monthTaken3: any;
  monthTaken8: any;
  monthTaken7: any;
  monthTaken6: any;
  monthTaken5: any;
  monthTaken4: any;
  hourValue9: any;
  hourValue10: any;
  lecVal9: any;
  lecVal10: any;
  monthTaken9: any;
  monthTaken10: any;

  course_name: any;
  edu_level: any;
  college_year: any;
  semester_auto: any;
  enrollYear = [];
  enrollment_year:any;
  startmonth;
  showcodeDropdown: boolean = true;
  showcodeDropdown2: boolean = true;
  showcodeDropdown3: boolean = true;
  showcodeDropdown4: boolean = true;
  showcodeDropdown5: boolean = true;
  showcodeDropdown6: boolean = true;
  showcodeDropdown7: boolean = true;
  showcodeDropdown8: boolean = true;
  showcodeDropdown9: boolean = true;
  showcodeDropdown10: boolean = true;
  public filterInput = new FormControl();
  public filterInput2 = new FormControl();
  public filterInput3 = new FormControl();
  public filterInput4 = new FormControl();
  public filterInput5 = new FormControl();
  public filterInput6 = new FormControl();
  public filterInput7 = new FormControl();
  public filterInput8 = new FormControl();
  public filterInput9 = new FormControl();
  public filterInput10 = new FormControl();
  autocheck = true;
  public filterText: any;
  public filterText2: any;
  public filterText3: any
  public filterText4: any;
  public filterText5: any;
  public filterText6: any;
  public filterText7: any;
  public filterText8: any;
  public filterText9: any;
  public filterText10: any;
  course_code: any;
  course_code8: any;
  course_code2: any;
  course_code3: any;
  course_code4: any;
  course_code5: any;
  course_code6: any;
  course_code7: any;
  course_code9: any;
  course_code10: any;
  subjectName: any;
  withoutCodeSub: any;
  subjectName2: any;
  withoutCodeSub2: any;
  withoutCodeSub3: any;
  subjectName3: any;
  subjectName4: any;
  withoutCodeSub4: any;
  subjectName5: any;
  withoutCodeSub5: any;
  subjectName6: any;
  withoutCodeSub6: any;
  subjectName7: any;
  withoutCodeSub7: any;
  subjectName8: any;
  withoutCodeSub8: any;
  subjectName9: any;
  withoutCodeSub9: any;
  subjectName10: any;
  withoutCodeSub10: any;
  newcourse_code = [];
  isDisabled = false;
  startYear;
  C_into_G: number;
  C_into_G2: number;
  C_into_G3: number;
  C_into_G4: number;
  C_into_G5: number;
  C_into_G6: number;
  C_into_G7: number;
  C_into_G8: number;
  C_into_G9: number;
  C_into_G10: number;
  constructor(protected api : ApiService,
    private router: Router,
    private userService: UserService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    protected ref: NbDialogRef<addEducationalDetailsSemesterBVOCGPA>) { }

  async ngOnInit() {
    if (this.admin_show == "true") {
      this.isDisabled = false;
    } else {
      //this.edu_form.controls['lecturehourFirstCtrl'].disable();

      this.isDisabled = !this.isDisabled;
    }
    
    // this.userService.onUserChange()
    // .subscribe((user: any) => this.user = user);
    // if(this.user.role == 'admin'){
    //   this.admin_show = false;
    // }

    this.edu_form = this.formBuilder.group({
      courseNameCtrl: [ '' ,  Validators.required],
      collegeYearCtrl : [ '' ,  Validators.required],
      semesterCtrl : [ '' ,  Validators.required],
      monthCtrl : [ '' ,  Validators.required],
      yearCtrl : [ '' ,  Validators.required],
      SpecialisationCtrl : [ '' ],
      endyearCtrl: [ '' ],
      endmonthCtrl : [ '' ],
      overAllGradeCtrl : [ '' ,  Validators.required],
      overAllgpasgpiCtrl : [ '' ,  Validators.required],
      subjectFirstCtrl : [ '' ],
      markFirstCtrl : [ '' ,  Validators.required],
      markFirstOutCtrl : [ '' ,  Validators.required],
      gradeFirstCtrl : [ '' ,  Validators.required],
      subjectSecondCtrl : [ '' ],
      markSecondCtrl : [ '' ],
      markSecondOutCtrl : [ '' ],
      gradeSecondCtrl : [ '' ],
      subjectThirdCtrl : [ '' ],
      markThirdCtrl : [ '' ],
      markThirdOutCtrl : [ '' ],
      gradeThirdCtrl : [ '' ],
      subjectFourthCtrl : [ '' ],
      markFourthCtrl : [ ''],
      markFourthOutCtrl : [ '' ],
      gradeFourthCtrl : [ '' ],
      clgCourseCtrl : [ '' ],
      subjectFifthCtrl : [ ''],
      markFifthCtrl : [ '' ],
      markFifthOutCtrl : [ '' ],
      gradeFifthCtrl : [''],
      subjectSixthCtrl : [ '' ],
      markSixthCtrl : [ ''],
      markSixthOutCtrl : [ ''],
      gradeSixthCtrl : [''],
      subjectSeventhCtrl : [ ''],
      markSeventhCtrl : [ ''],
      markSeventhOutCtrl : [ ''],
      gradeSeventhCtrl : [''],
      subjectEighthCtrl : [ ''],
      markEighthCtrl : [ ''],
      markEighthOutCtrl: [ ''],
      gradeEighthCtrl :[''],
      subjectNinthCtrl : [ ''],
      markNinthCtrl : [ ''],
      markNinthOutCtrl: [ ''],
      gradeNinthCtrl :[''],
      subjectTenthCtrl : [ ''],
      markTenthCtrl : [ ''],
      markTenthOutCtrl: [ ''],
      gradeTenthCtrl :[''],
      instructionCtrl : [ '' ,  Validators.required],
      specialInstrctionCtrl: [ ''],
      finalgradespecialInstrctionCtrl: [ ''],
      totalweeksCtrl : [ ''],

      hoursMinutesPerWeek1Ctrl : [ '' ],
      hoursMinutesPerWeek1Ctrl2 : [ ''],
      hoursMinutesPerWeek1Ctrl3 : [ '' ],
      hoursMinutesPerWeek1Ctrl4 : [ '' ],
      hoursMinutesPerWeek1Ctrl5 : [ '' ],
      hoursMinutesPerWeek1Ctrl6 : [ ''],
      hoursMinutesPerWeek1Ctrl7 : [ ''],
      hoursMinutesPerWeek1Ctrl8 : [ ''],
      lecturesPerWeekCtrl1 : [ '' ],
      lecturesPerWeekCtrl2 : [ '' ],
      lecturesPerWeekCtrl3 : [ '' ],
      lecturesPerWeekCtrl4 : [ '' ],
      lecturesPerWeekCtrl5 : [ '' ],
      lecturesPerWeekCtrl6 : [ ''],
      lecturesPerWeekCtrl7 : [ '' ],
      lecturesPerWeekCtrl8 : [ '' ],
      monthstakenCtrl : [ '' ],
      monthstakenCtrl2 : [ ''],
      monthstakenCtrl3: [ '' ],
      monthstakenCtrl4: [ '' ],
      monthstakenCtrl5: [ '' ],
      monthstakenCtrl6: [ ''],
      monthstakenCtrl7: [ ''],
      monthstakenCtrl8: [ '' ],
      

      creditsEarnedCFirstCtrl : [ '' ],
      creditsEarnedCSecondCtrl : [ '' ],
      creditsEarnedCThirdCtrl : [ '' ],
      creditsEarnedCFourthCtrl : [ '' ],
      creditsEarnedCFifthCtrl : [ ''],
      creditsEarnedCSixthCtrl : [ '' ],
      creditsEarnedCSevenCtrl : [ '' ],
      creditsEarnedCEightCtrl : [''],
      creditsEarnedCNinthCtrl : [ '' ],
      creditsEarnedCtehthCtrl : [ ''],
      gradepointsFirstCtrl : [ '' ,  Validators.required],
      gradecreditsFirstCtrl : [ '' ],
      gradepointsSecondCtrl : [ '' ],
      gradecreditsSecondCtrl : [ '' ],
      gradepointsThirdCtrl : [ '' ],
      gradecreditsThirdCtrl : [ '' ],
      gradepointsFourthCtrl : [ '' ],
      gradecreditsFourthCtrl : [ '' ],
      gradepointsFifthCtrl : [ ''],
      gradecreditsFifthCtrl : [ ''],
      gradepointsSixthCtrl : [ ''],
      gradecreditsSixthCtrl : [ ''],
      gradepointsSeventhCtrl : [ ''],
      gradecreditsSeventhCtrl : [ ''],
      gradepointsEighthCtrl : [ ''],
      gradecreditsEighthCtrl : [ ''],
      gradepointsNinthCtrl : [ ''],
      gradecreditsNinthCtrl : [ ''],
      gradepointsTenthCtrl : [ ''],
      gradecreditsTenthCtrl : [ ''],
      overmarksobtCtrl : [ '' ,  Validators.required],
      overmarksoutCtrl : [ '' ,  Validators.required],
      internalMarksCtrl : [ '' ,  Validators.required],
      internalMarksSecondCtrl : [ '' ],
      internalMarksThirdCtrl : [ '' ],
      internalMarksFourthCtrl : [ '' ],
      internalMarksFifthCtrl : [ ''],
      internalMarksSixthCtrl : [ ''],
      internalMarksSeventhCtrl : [ ''],
      internalMarksEightCtrl : [ ''],
      internalMarksNineCtrl : [''],
      internalMarksTenCtrl : [''],
      totalCCtrl : [ '' ,  Validators.required],
      totalCnGCtrl : [ '' ,  Validators.required],
      hoursMinutesPerWeek1Ctrl9: [''],
      lecturesPerWeekCtrl9: [''],
      monthstakenCtrl9: [''],
      hoursMinutesPerWeek1Ctrl10: [''],
      lecturesPerWeekCtrl10: [''],
      monthstakenCtrl10: [''],
      OverallCGPACtrl: [''],
      finalGradeCtrl: [''],
      startyearCtrl : [''],

    })

    if (this.college_year_auto == 'SemesterOne' || this.college_year_auto == 'SemesterTwo') {
      this.college_year = 'First';
      if (this.college_year_auto == 'SemesterOne') {
        this.semester_auto = 'I';
      } else {
        this.semester_auto = 'II';
      }
    } else if (this.college_year_auto == 'SemesterThree' || this.college_year_auto == 'SemesterFour') {
      this.college_year = 'Second';
      if (this.college_year_auto == 'SemesterThree') {
        this.semester_auto = 'III';
      } else {
        this.semester_auto = 'IV';
      }
    } else if (this.college_year_auto == 'SemesterFive' || this.college_year_auto == 'SemesterSix') {
      this.college_year = 'Third';
      if (this.college_year_auto == 'SemesterFive') {
        this.semester_auto = 'V';
      } else {
        this.semester_auto = 'VI';
      }
    }

    this.api.getCouses()
    .subscribe(
      (data: any) => {
        if (data['status'] == 200) {
          this.course_data = data['data'];
          if (this.course_name_auto != null) {
            this.course_data.forEach(element => {
              if (element.CourseName == this.course_name_auto || element.CourseShortForm == this.course_name_auto) {
                this.course_name = element.CourseShortForm;
                this.edu_level = element.type;
              }
            });
          }
         
        } else {

        }
        this.api.getCouseCode('sem',this.course_name,this.semester_auto,null).subscribe((data: any) => {
          if (data["status"] == 200) {
            
            this.autocheck = false;
            this.filterText = "";
            this.course_code = data["data"];
            this.filterInput.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText = term;
            });
            
            // this.autocheck = false;
            this.filterText2 = "";
            this.course_code2 = data["data"];
            this.filterInput2.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText2 = term;
            });

            // this.autocheck = false;
            this.filterText3 = "";
            this.course_code3 = data["data"];
            this.filterInput3.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText3 = term;
            });
            
            // this.autocheck = false;
            this.filterText4 = "";
            this.course_code4 = data["data"];
            this.filterInput4.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText4 = term;
            });

            // this.autocheck = false;
            this.filterText5 = "";
            this.course_code5 = data["data"];
            this.filterInput5.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText5 = term;
            });

            // this.autocheck = false;
            this.filterText6 = "";
            this.course_code6 = data["data"];
            this.filterInput6.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText6 = term;
            });

            // this.autocheck = false;
            this.filterText7 = "";
            this.course_code7 = data["data"];
            this.filterInput7.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText7 = term;
            });

            // this.autocheck = false;
            this.filterText8 = "";
            this.course_code8 = data["data"];
            this.filterInput8.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText8 = term;
            });

            // this.autocheck = false;
            this.filterText9 = "";
            this.course_code9 = data["data"];
            this.filterInput9.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText9 = term;
            });

            // this.autocheck = false;
            this.filterText10 = "";
            this.course_code10 = data["data"];
            this.filterInput10.valueChanges.debounceTime(200).subscribe((term) => {
              this.filterText10 = term;
            });

            
    
            
          } else {
          }
        });
      });

      this.api.getAllSpecialisation()
    .subscribe(
      (data: any) => {
        if (data['status'] == 200) {
          this.specialisation_data = data['data'];
          if (this.specialisationlevel_auto != null) {
            this.specialisation_data.forEach(element => {
              
              if (element.specialisation_name == this.specialisationlevel_auto) {
                this.specialisation_name = element.specialisation_name;
              }
            });
          }
         
        } else {

        }
      });

      
    const now = new Date().getUTCFullYear();    
    this.years_array = Array(now - (now - 50)).fill('').map((v, idx) => now - idx);
    for(let info of this.years_array){
      if(info >= this.enrollment_year_auto){
        this.enrollYear.push(info)
       }
    }
   
    
    if (this.user_id != null && this.edu_id != null) {
      this.api.getEducation(this.edu_id, this.user_id)
        .subscribe(
          (data: any) => {
            if (data['status'] == 200) {
              this.edu_data = data['data'];
              this.course_name = this.edu_data.CourseName;
              this.college_year = this.edu_data.CollegeYear;
              this.semester_auto = this.edu_data.Semester;
              this.enrollment_year = this.edu_data.Year;
              this.specialisation_name = this.edu_data.specialisation;
              if(this.edu_data.Subject_First != null && this.edu_data.Subject_First != '' && this.edu_data.Subject_First != undefined){
                this.showcodeDropdown = false
                
              }else{
                
                this.showcodeDropdown = true
              }
              if(this.edu_data.Subject_Second != null){
                this.showcodeDropdown2 = false
                
              }else{
                
                this.showcodeDropdown2 = true
              }
              if(this.edu_data.Subject_Third != null && this.edu_data.Subject_Third != '' && this.edu_data.Subject_Third != undefined){
                this.showcodeDropdown3 = false
                
              }else{
                
                this.showcodeDropdown3 = true
              }
              if(this.edu_data.Subject_Fourth != null && this.edu_data.Subject_Fourth != '' && this.edu_data.Subject_Fourth != undefined){
                this.showcodeDropdown4 = false
                
              }else{
                
                this.showcodeDropdown4 = true
              }
              if(this.edu_data.Subject_Fifth != null && this.edu_data.Subject_Fifth != '' && this.edu_data.Subject_Fifth != undefined){
                this.showcodeDropdown5 = false
                
              }else{
                
                this.showcodeDropdown5 = true
              }
              if(this.edu_data.Subject_Six != null && this.edu_data.Subject_Six != '' && this.edu_data.Subject_Six != undefined){
                this.showcodeDropdown6 = false
                
              }else{
                
                this.showcodeDropdown6 = true
              }
              if(this.edu_data.Subject_Seventh != null && this.edu_data.Subject_Seventh != '' && this.edu_data.Subject_Seventh != undefined){
                this.showcodeDropdown7 = false
                
              }else{
                
                this.showcodeDropdown7 = true
              }
              if(this.edu_data.Subject_Eighth != null && this.edu_data.Subject_Eighth != '' && this.edu_data.Subject_Eighth != undefined){
                this.showcodeDropdown8 = false
                
              }else{
                
                this.showcodeDropdown8 = true
              }
  
              if(this.edu_data.Subject_Ninth != null && this.edu_data.Subject_Ninth != '' && this.edu_data.Subject_Ninth != undefined){
                this.showcodeDropdown9 = false
                
              }else{
                
                this.showcodeDropdown9 = true
              }
              if(this.edu_data.Subject_Tenth != null && this.edu_data.Subject_Tenth != '' && this.edu_data.Subject_Tenth != undefined){
                this.showcodeDropdown10 = false
                
              }else{
                
                this.showcodeDropdown10 = true
              }
             
            } else {
              
            }
          });
    } else {
      
    }
  }

  getCourse(value) {
    
    //this.filterText = "";
    this.subjectName = value

    var count = 0
    this.newcourse_code = [];
    this.course_code.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code.length) {
        this.course_code = this.newcourse_code
      }
    })
    // if(value.prac == 'yes'){
    
    //   this.prac_hour1 = value.Lec_per_Week
    //   this.lec_per_week1 = '-'
    // }else{
    //   this.lec_per_week1 = value.Lec_per_Week
    //   this.prac_hour1 = '-'
    
    // }
    //this.filterPlaceholder = "Search";
    // this.adminApi.getAllCourse(value).subscribe((data)=>{
    //   this.courses = data['data'];
    // })
    // this.filterInput
    //   .valueChanges
    //   .debounceTime(200)
    //   .subscribe(term => {
    //   this.filterText = term;
    // });
  }

  getSubject(event: any) {
    
    this.withoutCodeSub = event.target.value
    if (this.subjectName) {
      
    } else {
      
    }
  }

  getCourse2(value) {
    
    //this.filterText = "";
    this.subjectName2 = value

    var count = 0
    this.newcourse_code = [];
    this.course_code3.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code3.length) {
        this.course_code3 = [];
        this.course_code3 = this.newcourse_code
      }
    })
    // if(value.prac == 'yes'){
    
    //   this.prac_hour2 = value.Lec_per_Week
    //   this.lec_per_week2 = '-'
    // }else{
    //   this.lec_per_week2 = value.Lec_per_Week
    //   this.prac_hour2 = '-'
    
    // }
  }

  getSubject2(event: any) {
    
    this.withoutCodeSub2 = event.target.value

  }

  getCourse3(value) {
    this.subjectName3 = value
    var count = 0
    var count = 0
    this.newcourse_code = [];
    this.course_code4.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id']) {
        
      } else {
        
        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code4.length) {
        this.course_code4 = [];
        this.course_code4 = this.newcourse_code
      }
    })
  }

  getSubject3(event: any) {
    this.withoutCodeSub3 = event.target.value
  }

  getCourse4(value) {

    this.subjectName4 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code5.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code5.length) {
        this.course_code5 = [];
        this.course_code5 = this.newcourse_code
      }
    })
  }

  getSubject4(event: any) {
    
    this.withoutCodeSub4 = event.target.value

  }

  getCourse5(value) {

    this.subjectName5 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code6.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code6.length) {
        this.course_code6 = [];
        this.course_code6 = this.newcourse_code
      }
    })
  }

  getSubject5(event: any) {
    
    this.withoutCodeSub5 = event.target.value

  }

  getCourse6(value) {

    this.subjectName6 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code7.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code7.length) {
        this.course_code7 = [];
        this.course_code7 = this.newcourse_code
      }
    })
  }

  getSubject6(event: any) {
    
    this.withoutCodeSub6 = event.target.value

  }

  getCourse7(value) {

    this.subjectName7 = value
    var count = 0
    this.newcourse_code = [];
    this.course_code8.forEach(element => {
      count++
      if (element['id'] == this.subjectName['id'] || element['id'] == this.subjectName2['id'] || element['id'] == this.subjectName3['id'] || element['id'] == this.subjectName4['id'] || element['id'] == this.subjectName5['id'] || element['id'] == this.subjectName6['id'] || element['id'] == this.subjectName7['id']) {

      } else {

        this.newcourse_code.push(element)

        
      }

      if (count == this.course_code8.length) {
        this.course_code8 = [];
        this.course_code8 = this.newcourse_code
      }
    })
  }

  getSubject8(event: any) {
    
    this.withoutCodeSub8 = event.target.value

  }
  getCourse8(value) {

    this.subjectName8 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour8 = value.Lec_per_Week
    //   this.lec_per_week8 = '-'
    // }else{
    //   this.lec_per_week8 = value.Lec_per_Week
    //   this.prac_hour8 = '-'
    
    // }
  }
  getSubject9(event: any) {
    
    this.withoutCodeSub9 = event.target.value

  }
  getCourse10(value) {

    this.subjectName10 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour10 = value.Lec_per_Week
    //   this.lec_per_week10 = '-'
    // }else{
    //   this.lec_per_week10 = value.Lec_per_Week
    //   this.prac_hour10 = '-'
    
    // }
  }

  getSubject10(event: any) {
    
    this.withoutCodeSub10 = event.target.value

  }
  getCourse9(value) {

    this.subjectName9 = value
    // if(value.prac == 'yes'){
    
    //   this.prac_hour9 = value.Lec_per_Week
    //   this.lec_per_week9 = '-'
    // }else{
    //   this.lec_per_week9 = value.Lec_per_Week
    //   this.prac_hour9 = '-'
    
    // }
  }

  getSubject7(event: any) {
    
    this.withoutCodeSub7 = event.target.value

  }

  showcoursecodeDropdown(){
    this.showcodeDropdown = true
  }
  
  showcoursecodeDropdown2(){
    this.showcodeDropdown2 = true
  }
  
  showcoursecodeDropdown3(){
    this.showcodeDropdown3 = true
  }
  
  showcoursecodeDropdown4(){
    this.showcodeDropdown4 = true
  }
  
  showcoursecodeDropdown5(){
    this.showcodeDropdown5 = true
  }
  
  showcoursecodeDropdown6(){
    this.showcodeDropdown6 = true
  }
  
  showcoursecodeDropdown7(){
    this.showcodeDropdown7 = true
  }
  
  showcoursecodeDropdown8(){
    this.showcodeDropdown8 = true
  }

  showcoursecodeDropdown9(){
    this.showcodeDropdown9 = true
  }
  
  showcoursecodeDropdown10(){
    this.showcodeDropdown10 = true
  }
  
  showContactDetails(){
    this.confirmationService.confirm({
      message: 'Email - lsraheja@etranscript.in &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp;'+' Whatsapp -  022 2287 6115'  ,
      header: 'Please contact the admin on ',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
                
      },
      reject: () => {
        
      }
    });
  }
  
  saveEdu() {
    this.courseValidation = true;
    this.collegeYearValidation = true;
    this.semesterValidation = true;
    this.monthValidation = true;
    this.yearValidation = true;
    this.attemptValidation = true;
    this.instructionValidation = true;
    this.endYearValidation = true;

    if(this.edu_form.controls.semesterCtrl.value){
      if(this.edu_form.controls.endmonthCtrl.value){
        this.startmonth = this.edu_form.controls.endmonthCtrl.value
      }else{
        if(this.edu_form.controls.semesterCtrl.value == 'I' || this.edu_form.controls.semesterCtrl.value ==  'III' || this.edu_form.controls.semesterCtrl.value == 'V'){
          this.startmonth = 'June'
        }else{
          this.startmonth =  'November'
        }
      }
      
    }
    
    if (this.edu_form.valid == false) {
      this.edu_form.controls.courseNameCtrl.markAsDirty();
      this.edu_form.controls.overAllGradeCtrl.markAsDirty();
      this.edu_form.controls.overAllgpasgpiCtrl.markAsDirty();
      //this.edu_form.controls.subjectFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstCtrl.markAsDirty();
      this.edu_form.controls.markFirstOutCtrl.markAsDirty();
      this.edu_form.controls.gradeFirstCtrl.markAsDirty();
      this.edu_form.controls.gradepointsFirstCtrl.markAsDirty();
      this.edu_form.controls.gradecreditsFirstCtrl.markAsDirty();
      // this.edu_form.controls.subjectSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondCtrl.markAsDirty();
      // this.edu_form.controls.markSecondOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsSecondCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsSecondCtrl.markAsDirty();
      // this.edu_form.controls.subjectThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdCtrl.markAsDirty();
      // this.edu_form.controls.markThirdOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsThirdCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsThirdCtrl.markAsDirty();
      // this.edu_form.controls.subjectFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthCtrl.markAsDirty();
      // this.edu_form.controls.markFourthOutCtrl.markAsDirty();
      // this.edu_form.controls.gradeFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradepointsFourthCtrl.markAsDirty();
      // this.edu_form.controls.gradecreditsFourthCtrl.markAsDirty();
      this.edu_form.controls.instructionCtrl.markAsDirty();
      this.edu_form.controls.totalCCtrl.markAsDirty();
      this.edu_form.controls.totalCnGCtrl.markAsDirty();

      if (this.edu_form.controls.instructionCtrl.value === null || this.edu_form.controls.instructionCtrl.value === '' || this.edu_form.controls.instructionCtrl.value === undefined) {
        this.instructionValidation = false;
      } else {
        this.instructionValidation = true;
      }

      if (this.edu_form.controls.courseNameCtrl.value === null || this.edu_form.controls.courseNameCtrl.value === '' || this.edu_form.controls.courseNameCtrl.value === undefined) {
        this.courseValidation = false;
      } else {
        this.courseValidation = true;
      }

      if (this.edu_form.controls.collegeYearCtrl.value === null || this.edu_form.controls.collegeYearCtrl.value === '' || this.edu_form.controls.collegeYearCtrl.value === undefined) {
        this.collegeYearValidation = false;
      } else {
        this.collegeYearValidation = true;
      }

      if (this.edu_form.controls.semesterCtrl.value === null || this.edu_form.controls.semesterCtrl.value === '' || this.edu_form.controls.semesterCtrl.value === undefined) {
        this.semesterValidation = false;
      } else {
        this.semesterValidation = true;
      }

      if (this.edu_form.controls.monthCtrl.value === null || this.edu_form.controls.monthCtrl.value === '' || this.edu_form.controls.monthCtrl.value === undefined) {
        this.monthValidation = false;
      } else {
        this.monthValidation = true;
      }

      if (this.edu_form.controls.yearCtrl.value === null || this.edu_form.controls.yearCtrl.value === '' || this.edu_form.controls.yearCtrl.value === undefined) {
        this.yearValidation = false;
      } else {
        this.yearValidation = true;
      }

      // if(this.edu_form.controls.endmonthCtrl.value === null || this.edu_form.controls.endmonthCtrl.value ==='' || this.edu_form.controls.endmonthCtrl.value ===undefined){
      //   this.endmonthValidation = false;
      // }else {
      //   this.endmonthValidation = true;
      // }

      // if(this.edu_form.controls.endyearCtrl.value === null || this.edu_form.controls.endyearCtrl.value ==='' || this.edu_form.controls.endyearCtrl.value ===undefined){
      //   this.endYearValidation = false;
      // }else {
      //   this.endYearValidation = true;
      // }
    } else {
      
      var edu_data = {
        courseName: this.edu_form.controls.courseNameCtrl.value,
        collegeYear: this.edu_form.controls.collegeYearCtrl.value,
        semester: this.edu_form.controls.semesterCtrl.value,
        month: this.edu_form.controls.monthCtrl.value,
        year: this.edu_form.controls.yearCtrl.value,
        endmonth: this.startmonth ? this.startmonth : this.edu_form.controls.endmonthCtrl.value,
        startYear: this.startYear ? this.startYear : this.edu_form.controls.startyearCtrl.value,
        specialisation : this.edu_form.controls.SpecialisationCtrl.value,
        endYear: this.edu_form.controls.endyearCtrl.value,
        overAllGrade: this.edu_form.controls.overAllGradeCtrl.value,
        overall_gpa_sgpi: this.edu_form.controls.overAllgpasgpiCtrl.value,
        subjectFirst: this.subjectName ? this.subjectName['Course_Subject_name'] : this.withoutCodeSub,
        //subjectFirst : this.edu_form.controls.subjectFirstCtrl.value,
        marks_obt_First: this.edu_form.controls.markFirstCtrl.value,
        marks_out_First: this.edu_form.controls.markFirstOutCtrl.value,
        markFirst: this.edu_form.controls.gradeFirstCtrl.value,
        grade_points_First: this.edu_form.controls.gradepointsFirstCtrl.value,
        grade_credits_First: this.edu_form.controls.gradecreditsFirstCtrl.value,
        //subjectSecond : this.edu_form.controls.subjectSecondCtrl.value,
        subjectSecond: this.subjectName2 ? this.subjectName2['Course_Subject_name'] : this.withoutCodeSub2,
        marks_obt_Second: this.edu_form.controls.markSecondCtrl.value,
        marks_out_Second: this.edu_form.controls.markSecondOutCtrl.value,
        markSecond: this.edu_form.controls.gradeSecondCtrl.value,
        grade_points_Second: this.edu_form.controls.gradepointsSecondCtrl.value,
        grade_credits_Second: this.edu_form.controls.gradecreditsSecondCtrl.value,
        subjectThird: this.subjectName3 ? this.subjectName3['Course_Subject_name'] : this.withoutCodeSub3,
        //subjectThird : this.edu_form.controls.subjectThirdCtrl.value,
        marks_obt_Third: this.edu_form.controls.markThirdCtrl.value,
        marks_out_Third: this.edu_form.controls.markThirdOutCtrl.value,
        markThird: this.edu_form.controls.gradeThirdCtrl.value,
        grade_points_Third: this.edu_form.controls.gradepointsThirdCtrl.value,
        grade_credits_Third: this.edu_form.controls.gradecreditsThirdCtrl.value,
        subjectFourth: this.subjectName4 ? this.subjectName4['Course_Subject_name'] : this.withoutCodeSub4,
        //subjectFourth : this.edu_form.controls.subjectFourthCtrl.value,
        marks_obt_Fourth: this.edu_form.controls.markFourthCtrl.value,
        marks_out_Fourth: this.edu_form.controls.markFourthOutCtrl.value,
        markFourth: this.edu_form.controls.gradeFourthCtrl.value,
        grade_points_Fourth: this.edu_form.controls.gradepointsFourthCtrl.value,
        grade_credits_Fourth: this.edu_form.controls.gradecreditsFourthCtrl.value,
        subjectFifth: this.subjectName5 ? this.subjectName5['Course_Subject_name'] : this.withoutCodeSub5,
        //subjectFifth : this.edu_form.controls.subjectFifthCtrl.value,
        marks_obt_Fifth: this.edu_form.controls.markFifthCtrl.value,
        marks_out_Fifth: this.edu_form.controls.markFifthOutCtrl.value,
        markFifth: this.edu_form.controls.gradeFifthCtrl.value,
        grade_points_Fifth: this.edu_form.controls.gradepointsFifthCtrl.value,
        grade_credits_Fifth: this.edu_form.controls.gradecreditsFifthCtrl.value,
        //subjectSixth : this.edu_form.controls.subjectSixthCtrl.value,
        subjectSixth: this.subjectName6 ? this.subjectName6['Course_Subject_name'] : this.withoutCodeSub6,
        marks_obt_Six: this.edu_form.controls.markSixthCtrl.value,
        marks_out_Six: this.edu_form.controls.markSixthOutCtrl.value,
        markSixth: this.edu_form.controls.gradeSixthCtrl.value,
        grade_points_Six: this.edu_form.controls.gradepointsSixthCtrl.value,
        grade_credits_Six: this.edu_form.controls.gradecreditsSixthCtrl.value,
        subjectSeventh: this.subjectName7 ? this.subjectName7['Course_Subject_name'] : this.withoutCodeSub7,
        //subjectSeventh : this.edu_form.controls.subjectSeventhCtrl.value,
        marks_obt_Seventh: this.edu_form.controls.markSeventhCtrl.value,
        marks_out_Seventh: this.edu_form.controls.markSeventhOutCtrl.value,
        markSeventh: this.edu_form.controls.gradeSeventhCtrl.value,
        grade_points_Seventh: this.edu_form.controls.gradepointsSeventhCtrl.value,
        grade_credits_Seventh: this.edu_form.controls.gradecreditsSeventhCtrl.value,
        subjectEighth: this.subjectName8 ? this.subjectName8['Course_Subject_name'] : this.withoutCodeSub8,
        //subjectEighth : this.edu_form.controls.subjectEighthCtrl.value,
        marks_obt_Eighth: this.edu_form.controls.markEighthCtrl.value,
        marks_out_Eighth: this.edu_form.controls.markEighthOutCtrl.value,
        markEighth: this.edu_form.controls.gradeEighthCtrl.value,
        grade_points_Eighth: this.edu_form.controls.gradepointsEighthCtrl.value,
        grade_credits_Eighth: this.edu_form.controls.gradecreditsEighthCtrl.value,
        subjectNinth: this.subjectName9 ? this.subjectName9['Course_Subject_name'] : this.withoutCodeSub9,
        //subjectNinth : this.edu_form.controls.subjectNinthCtrl.value,
        marks_obt_Ninth: this.edu_form.controls.markNinthCtrl.value,
        marks_out_Ninth: this.edu_form.controls.markNinthOutCtrl.value,
        markNinth: this.edu_form.controls.gradeNinthCtrl.value,
        grade_points_Ninth: this.edu_form.controls.gradepointsNinthCtrl.value,
        grade_credits_Ninth: this.edu_form.controls.gradecreditsNinthCtrl.value,
        subjectTenth: this.subjectName10 ? this.subjectName10['Course_Subject_name'] : this.withoutCodeSub10,
        //subjectTenth : this.edu_form.controls.subjectTenthCtrl.value,
        marks_obt_Tenth: this.edu_form.controls.markTenthCtrl.value,
        marks_out_Tenth: this.edu_form.controls.markTenthOutCtrl.value,
        markTenth: this.edu_form.controls.gradeTenthCtrl.value,
        grade_points_Tenth: this.edu_form.controls.gradepointsTenthCtrl.value,
        grade_credits_Tenth: this.edu_form.controls.gradecreditsTenthCtrl.value,
        user_id: this.user_id,
        medium_instruction: this.edu_form.controls.instructionCtrl.value,
        id: this.edu_id,
        // special_instruction: this.specialInstruction ? this.specialInstruction : this.specI,
        // final_grade_special_instruction: this.GradespecialInstruction ? this.GradespecialInstruction : this.DradespecI,
        // special_instruction : this.edu_form.controls.specialInstrctionCtrl.value,
        // final_grade_special_instruction : this.edu_form.controls.finalgradespecialInstrctionCtrl.value,
        total_weeks: this.edu_form.controls.totalweeksCtrl.value,
        internal_Marks: this.edu_form.controls.internalMarksCtrl.value,
        internal_Marks_Second: this.edu_form.controls.internalMarksSecondCtrl.value,
        internal_Marks_Third: this.edu_form.controls.internalMarksThirdCtrl.value,
        internal_Marks_Fourth: this.edu_form.controls.internalMarksFourthCtrl.value,
        internal_Marks_Fifth: this.edu_form.controls.internalMarksFifthCtrl.value,
        internal_Marks_Sixth: this.edu_form.controls.internalMarksSixthCtrl.value,
        internal_Marks_Seventh: this.edu_form.controls.internalMarksSeventhCtrl.value,
        internal_Marks_Eight: this.edu_form.controls.internalMarksEightCtrl.value,
        internal_Marks_Nine: this.edu_form.controls.internalMarksNineCtrl.value,
        internal_Marks_Ten: this.edu_form.controls.internalMarksTenCtrl.value,
        credits_Earned_c_First: this.edu_form.controls.creditsEarnedCFirstCtrl.value,
        credits_Earned_c_Second: this.edu_form.controls.creditsEarnedCSecondCtrl.value,
        credits_Earned_c_Third: this.edu_form.controls.creditsEarnedCThirdCtrl.value,
        credits_Earned_c_Fourth: this.edu_form.controls.creditsEarnedCFourthCtrl.value,
        credits_Earned_c_Fifth: this.edu_form.controls.creditsEarnedCFifthCtrl.value,
        credits_Earned_c_Sixth: this.edu_form.controls.creditsEarnedCSixthCtrl.value,
        credits_Earned_c_Seven: this.edu_form.controls.creditsEarnedCSevenCtrl.value,
        credits_Earned_c_Eight: this.edu_form.controls.creditsEarnedCEightCtrl.value,
        credits_Earned_c_Ninth: this.edu_form.controls.creditsEarnedCNinthCtrl.value,
        credits_Earned_c_tehth: this.edu_form.controls.creditsEarnedCtehthCtrl.value,
        practical_hour_First: this.subjectName ? this.subjectName['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value,
        practical_hour_Second: this.subjectName2 ? this.subjectName2['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl2.value,
        practical_hour_Third: this.subjectName3 ? this.subjectName3['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl3.value,
        practical_hour_Fourth: this.subjectName4 ? this.subjectName4['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl4.value,
        practical_hour_Fifth: this.subjectName5 ? this.subjectName5['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl5.value,
        practical_hour_Six: this.subjectName6 ? this.subjectName6['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl6.value,
        practical_hour_Seventh: this.subjectName7 ? this.subjectName7['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl7.value,
        practical_hour_Eighth: this.subjectName8 ? this.subjectName8['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl8.value,
        lecture_hour_First: this.subjectName ? this.subjectName['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl1.value,
        lecture_hour_Second: this.subjectName2 ? this.subjectName2['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl2.value,
        lecture_hour_Third: this.subjectName3 ? this.subjectName3['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl3.value,
        lecture_hour_Fourth: this.subjectName4 ? this.subjectName4['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl4.value,
        lecture_hour_Fifth: this.subjectName5 ? this.subjectName5['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl5.value,
        lecture_hour_Six: this.subjectName6 ? this.subjectName6['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl6.value,
        lecture_hour_Seventh: this.subjectName7 ? this.subjectName7['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl7.value,
        lecture_hour_Eighth: this.subjectName8 ? this.subjectName8['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl8.value,
        months_taken_First  : this.subjectName ? this.subjectName['Months_taken'] : this.edu_form.controls.monthstakenCtrl.value ,
        months_taken_Second  : this.subjectName2 ? this.subjectName2['Months_taken'] : this.edu_form.controls.monthstakenCtrl2.value ,
        months_taken_Third  :this.subjectName3 ? this.subjectName3['Months_taken'] :  this.edu_form.controls.monthstakenCtrl3.value,
        months_taken_Fourth :this.subjectName4 ? this.subjectName4['Months_taken'] : this.edu_form.controls.monthstakenCtrl4.value ,
        months_taken_Fifth  :this.subjectName5 ?  this.subjectName5['Months_taken'] : this.edu_form.controls.monthstakenCtrl5.value ,
        months_taken_Six  :this.subjectName6 ? this.subjectName6['Months_taken'] : this.edu_form.controls.monthstakenCtrl6.value ,
        months_taken_Seventh  :this.subjectName7 ? this.subjectName7['Months_taken'] : this.edu_form.controls.monthstakenCtrl7.value ,
        months_taken_Eighth  :this.subjectName8 ? this.subjectName8['Months_taken']  : this.edu_form.controls.monthstakenCtrl8.value ,
        months_taken_ninth  :this.subjectName9 ? this.subjectName9['Months_taken']  : this.edu_form.controls.monthstakenCtrl9.value ,
        months_taken_tenth   :this.subjectName10 ? this.subjectName10['Months_taken']  : this.edu_form.controls.monthstakenCtrl10.value ,
        lecture_hour_Ninth: this.subjectName9 ? this.subjectName9['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl9.value,
        practical_hour_Ninth: this.subjectName9 ? this.subjectName9['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl9.value,
        monthstakenCtrl9  :this.subjectName9 ? this.subjectName9['Months_taken']  : this.edu_form.controls.monthstakenCtrl9.value ,
        practical_hour_Tenth: this.subjectName10 ? this.subjectName10['Hours_and_Minutes_per_Week'] : this.edu_form.controls.hoursMinutesPerWeek1Ctrl10.value,
        lecture_hour_Tenth: this.subjectName10 ? this.subjectName10['Lectures_per_Week'] : this.edu_form.controls.lecturesPerWeekCtrl10.value,
        monthstakenCtrl10  :this.subjectName10 ? this.subjectName10['Months_taken']  : this.edu_form.controls.monthstakenCtrl10.value ,
        //months_taken_tenth: this.subjectName10 ? (this.edu_form.controls.monthstakenCtrl10.value ? this.edu_form.controls.monthstakenCtrl10.value : '4') : '',
        totalC: this.edu_form.controls.totalCCtrl.value,
        totalCnG: this.edu_form.controls.totalCnGCtrl.value,
        overall_CGPA: this.edu_form.controls.OverallCGPACtrl.value,
        overAllYearlyGrade: this.edu_form.controls.finalGradeCtrl.value,
        sgpi_gpa: 'sgpi'
        
      }

      this.api.setEducationalValues(edu_data)
        .subscribe(
          (data: any) => {
            this.ref.close(data);
            err => console.error(err)
          });
    }
  }

  //to check which form control is invalid
	public findInvalidControls(controls) {
		const invalid = [];
	   
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	  }

  dismiss() {
    this.ref.close();
  }

  myFunc(){
    
    
    if(this.edu_form.controls.markFirstCtrl.value && this.edu_form.controls.internalMarksCtrl.value){
      this.totalValue = parseInt(this.edu_form.controls.markFirstCtrl.value) + parseInt(this.edu_form.controls.internalMarksCtrl.value)
    }
    if(this.edu_form.controls.internalMarksSecondCtrl.value && this.edu_form.controls.markSecondCtrl.value){
      
      this.totalValue2 = parseInt(this.edu_form.controls.internalMarksSecondCtrl.value) + parseInt(this.edu_form.controls.markSecondCtrl.value)
    }

    if(this.edu_form.controls.internalMarksThirdCtrl.value && this.edu_form.controls.markThirdCtrl.value){
      
      this.totalValue3 = parseInt(this.edu_form.controls.internalMarksThirdCtrl.value) + parseInt(this.edu_form.controls.markThirdCtrl.value)
    }
    if(this.edu_form.controls.internalMarksFourthCtrl.value && this.edu_form.controls.markFourthCtrl.value){
      
      this.totalValue4 = parseInt(this.edu_form.controls.internalMarksFourthCtrl.value) + parseInt(this.edu_form.controls.markFourthCtrl.value)
    }
    if(this.edu_form.controls.internalMarksFifthCtrl.value && this.edu_form.controls.markFifthCtrl.value){
      
      this.totalValue5 = parseInt(this.edu_form.controls.internalMarksFifthCtrl.value) + parseInt(this.edu_form.controls.markFifthCtrl.value)
    }
    if(this.edu_form.controls.internalMarksSixthCtrl.value && this.edu_form.controls.markSixthCtrl.value){
      
      this.totalValue6 = parseInt(this.edu_form.controls.internalMarksSixthCtrl.value) + parseInt(this.edu_form.controls.markSixthCtrl.value)
    }
    if(this.edu_form.controls.internalMarksSeventhCtrl.value && this.edu_form.controls.markSeventhCtrl.value){
      
      this.totalValue7 = parseInt(this.edu_form.controls.internalMarksSeventhCtrl.value) + parseInt(this.edu_form.controls.markSeventhCtrl.value)
    }
    if(this.edu_form.controls.internalMarksEightCtrl.value && this.edu_form.controls.markEighthCtrl.value){
      
      this.totalValue8 = parseInt(this.edu_form.controls.internalMarksEightCtrl.value) + parseInt(this.edu_form.controls.markEighthCtrl.value)
    }
    if(this.edu_form.controls.internalMarksNineCtrl.value && this.edu_form.controls.internalMarksNineCtrl.value){
      
      this.totalValue9 = parseInt(this.edu_form.controls.internalMarksNineCtrl.value) + parseInt(this.edu_form.controls.markNinthCtrl.value)
    }
    if(this.edu_form.controls.internalMarksTenCtrl.value && this.edu_form.controls.markTenthCtrl.value){
     
      this.totalValue10 = parseInt(this.edu_form.controls.internalMarksTenCtrl.value) + parseInt(this.edu_form.controls.markTenthCtrl.value)
    }
    
    
  }

  hetmarksObt(){
    this.totalMarks = 0
    
    if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != '' && this.edu_form.controls.markEighthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value) + Number(this.edu_form.controls.markEighthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' && this.edu_form.controls.markSeventhCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value) + Number(this.edu_form.controls.markSeventhCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' && this.edu_form.controls.markSixthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value) + Number(this.edu_form.controls.markSixthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != '' && this.edu_form.controls.markFifthCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value) + Number(this.edu_form.controls.markFifthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' && this.edu_form.controls.markFourthCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) + Number(this.edu_form.controls.markFourthCtrl.value))
      
    }else if(this.edu_form.controls.markSecondCtrl.value != '' && this.edu_form.controls.markThirdCtrl.value != '' ){
      this.totalMarks = (Number(this.edu_form.controls.markFirstCtrl.value) + Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markThirdCtrl.value) )
      
    }else if(this.edu_form.controls.markSecondCtrl.value != ''){
      this.totalMarks = (Number(this.edu_form.controls.markSecondCtrl.value) + Number(this.edu_form.controls.markFirstCtrl.value))
      
    }
  }

 totalsMarksOut(){
   this.totalMarksOut = 0
   if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != '' && this.edu_form.controls.markEighthOutCtrl.value){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value) + Number(this.edu_form.controls.markEighthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' && this.edu_form.controls.markSeventhOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value) + Number(this.edu_form.controls.markSeventhOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' && this.edu_form.controls.markSixthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value) + Number(this.edu_form.controls.markSixthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' && this.edu_form.controls.markFifthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value) + Number(this.edu_form.controls.markFifthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != '' && this.edu_form.controls.markFourthOutCtrl.value != '' ){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value)+ Number(this.edu_form.controls.markFourthOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != '' && this.edu_form.controls.markThirdOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value) + Number(this.edu_form.controls.markThirdOutCtrl.value))
   }else if(this.edu_form.controls.markSecondOutCtrl.value != ''){
    this.totalMarksOut = (Number(this.edu_form.controls.markFirstOutCtrl.value) + Number(this.edu_form.controls.markSecondOutCtrl.value))
   }
 }

 getTotalCredits(){
  this.creditTotal = 0
  if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.creditsEarnedCtenthCtrl.value){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCtenthCtrl.value))
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.creditsEarnedCNinthCtrl.value){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) + Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value))
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.creditsEarnedCEightCtrl.value){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) + Number(this.edu_form.controls.creditsEarnedCEightCtrl.value))
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.creditsEarnedCSevenCtrl.value){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) )
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value ){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) )
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.creditsEarnedCFifthCtrl.value ){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value)  )
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.creditsEarnedCFourthCtrl.value ){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) + Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) )
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.creditsEarnedCThirdCtrl.value ){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) + Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) )
  }else if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.creditsEarnedCSecondCtrl.value ){
   this.creditTotal = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) + Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) )
  }

}


getTotalCnG(){
 this.totalCnG = 0;

 if(this.edu_form.controls.creditsEarnedCFirstCtrl.value && this.edu_form.controls.gradepointsFirstCtrl.value){
     this.C_into_G = (Number(this.edu_form.controls.creditsEarnedCFirstCtrl.value) *  Number(this.edu_form.controls.gradepointsFirstCtrl.value))
  

     if(this.C_into_G>0){
       this.totalCnG = this.totalCnG + this.C_into_G;

       if(this.totalCnG && this.creditTotal){
         this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
         this.totalcgpa = Number(this.totalcgpa.toFixed(2))
        }
     }
   }
 if(this.edu_form.controls.creditsEarnedCSecondCtrl.value && this.edu_form.controls.gradepointsSecondCtrl.value){
    this.C_into_G2 = (Number(this.edu_form.controls.creditsEarnedCSecondCtrl.value) *  Number(this.edu_form.controls.gradepointsSecondCtrl.value))

    if(this.C_into_G2>0){
     this.totalCnG = this.totalCnG + this.C_into_G2;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCThirdCtrl.value && this.edu_form.controls.gradepointsThirdCtrl.value){
   this.C_into_G3 = (Number(this.edu_form.controls.creditsEarnedCThirdCtrl.value) *  Number(this.edu_form.controls.gradepointsThirdCtrl.value))
  
   if(this.C_into_G3>0){
     this.totalCnG = this.totalCnG + this.C_into_G3;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCFourthCtrl.value && this.edu_form.controls.gradepointsFourthCtrl.value){
   this.C_into_G4 = (Number(this.edu_form.controls.creditsEarnedCFourthCtrl.value) *  Number(this.edu_form.controls.gradepointsFourthCtrl.value))

   if(this.C_into_G4>0){
     this.totalCnG = this.totalCnG + this.C_into_G4;


     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }

  }
  if(this.edu_form.controls.creditsEarnedCFifthCtrl.value && this.edu_form.controls.gradepointsFifthCtrl.value){
   this.C_into_G5 = (Number(this.edu_form.controls.creditsEarnedCFifthCtrl.value) *  Number(this.edu_form.controls.gradepointsFifthCtrl.value))

   if(this.C_into_G5>0){
     this.totalCnG = this.totalCnG + this.C_into_G5;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCSixthCtrl.value && this.edu_form.controls.gradepointsSixthCtrl.value){
   this.C_into_G6 = (Number(this.edu_form.controls.creditsEarnedCSixthCtrl.value) *  Number(this.edu_form.controls.gradepointsSixthCtrl.value))
   if(this.C_into_G6>0){
     this.totalCnG = this.totalCnG + this.C_into_G6;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCSevenCtrl.value && this.edu_form.controls.gradepointsSeventhCtrl.value){
   this.C_into_G7 = (Number(this.edu_form.controls.creditsEarnedCSevenCtrl.value) *  Number(this.edu_form.controls.gradepointsSeventhCtrl.value))
   if(this.C_into_G7>0){
     this.totalCnG = this.totalCnG + this.C_into_G7;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCEightCtrl.value && this.edu_form.controls.gradepointsEighthCtrl.value){
   this.C_into_G8 = (Number(this.edu_form.controls.creditsEarnedCEightCtrl.value) *  Number(this.edu_form.controls.gradepointsEighthCtrl.value))
   if(this.C_into_G8>0){
     this.totalCnG = this.totalCnG + this.C_into_G8;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCNinthCtrl.value && this.edu_form.controls.gradepointsNinthCtrl.value){
   this.C_into_G9 = (Number(this.edu_form.controls.creditsEarnedCNinthCtrl.value) *  Number(this.edu_form.controls.gradepointsNinthCtrl.value))
   if(this.C_into_G9>0){
     this.totalCnG = this.totalCnG + this.C_into_G9;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }
  }
  if(this.edu_form.controls.creditsEarnedCtenthCtrl.value && this.edu_form.controls.gradepointsTenthCtrl.value){
   this.C_into_G10 = (Number(this.edu_form.controls.creditsEarnedCtenthCtrl.value) *  Number(this.edu_form.controls.gradepointsTenthCtrl.value))
   if(this.C_into_G10>0){
     this.totalCnG = this.totalCnG + this.C_into_G10;

     if(this.totalCnG && this.creditTotal){
       this.totalcgpa = Number(this.totalCnG) / Number(this.creditTotal)
       this.totalcgpa = Number(this.totalcgpa.toFixed(2))
      }
   }

  }

 //to check which form control is invalid
// public findInvalidControls(controls) {
// const invalid = [];

// for (const name in controls) {
// if (controls[name].invalid) {
// invalid.push(name);
// }
// }
// return invalid;
 //   }
}

  copyHoursValue(){
    
    if(this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value){
      if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value && this.edu_form.controls.subjectTenthCtrl.value    ){
        this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue9 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue10 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
 
       
 
 
      }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value  ){
        this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue9 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
 
       
 
 
      }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value      ){
        this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue6 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue7 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        this.hourValue8 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
 
       
 
 
      }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value ){
       this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue6 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       this.hourValue7 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
       }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value ){
         this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue6 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        
       }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value  ){
         this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue5 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
        
       }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value ){
         this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue4 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         
       }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value ){
         this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue3 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         
         
       }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value ){
         this.hourValue =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         this.hourValue2 =  this.edu_form.controls.hoursMinutesPerWeek1Ctrl.value;
         
         
         
       }
      
     
    }
  }
 
  copyLecValue(){
   if(this.edu_form.controls.lecturehourFirstCtrl.value){
    if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value && this.edu_form.controls.subjectTenthCtrl.value    ){
        this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal6=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal7=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal8=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal9=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal10=  this.edu_form.controls.lecturehourFirstCtrl.value;
    }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value  ){
      this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal6=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal7=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal8=  this.edu_form.controls.lecturehourFirstCtrl.value;
     this.lecVal9=  this.edu_form.controls.lecturehourFirstCtrl.value;
     
    }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value      ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal6=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal7=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal8=  this.edu_form.controls.lecturehourFirstCtrl.value;
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value     ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal6=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal7=  this.edu_form.controls.lecturehourFirstCtrl.value;
       
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value    ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal6=  this.edu_form.controls.lecturehourFirstCtrl.value;
       
       
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value   ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal5=  this.edu_form.controls.lecturehourFirstCtrl.value;
       
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value   ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal4=  this.edu_form.controls.lecturehourFirstCtrl.value;
       
       
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value  ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal3=  this.edu_form.controls.lecturehourFirstCtrl.value;
     
     }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value  ){
       this.lecVal1 =  this.edu_form.controls.lecturehourFirstCtrl.value;
       this.lecVal2=  this.edu_form.controls.lecturehourFirstCtrl.value;
       
     
     }
    }
  }
 
  copyMonthValue(){
    if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value && this.edu_form.controls.subjectTenthCtrl.value    ){
      if(this.edu_form.controls.monthstakenCtrl.value){
        this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken6=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken7=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken8=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken9=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken10=  this.edu_form.controls.monthstakenCtrl.value;
       }
    }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value   && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectNinthCtrl.value ){
      if(this.edu_form.controls.monthstakenCtrl.value){
        this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken6=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken7=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken8=  this.edu_form.controls.monthstakenCtrl.value;
        this.monthTaken9=  this.edu_form.controls.monthstakenCtrl.value;
       }
    }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value && this.edu_form.controls.subjectEighthCtrl.value      ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken6=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken7=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken8=  this.edu_form.controls.monthstakenCtrl.value;
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value && this.edu_form.controls.subjectSeventhCtrl.value     ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken6=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken7=  this.edu_form.controls.monthstakenCtrl.value;
       
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value && this.edu_form.controls.subjectSixthCtrl.value    ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken6=  this.edu_form.controls.monthstakenCtrl.value;
       
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value && this.edu_form.controls.subjectFifthCtrl.value  ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken5=  this.edu_form.controls.monthstakenCtrl.value;
       
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value && this.edu_form.controls.subjectFourthCtrl.value ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken4=  this.edu_form.controls.monthstakenCtrl.value;
       
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value && this.edu_form.controls.subjectThirdCtrl.value){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken3=  this.edu_form.controls.monthstakenCtrl.value;
       
      }
   }else if(this.edu_form.controls.subjectFirstCtrl.value && this.edu_form.controls.subjectSecondCtrl.value ){
     if(this.edu_form.controls.monthstakenCtrl.value){
       this.monthTaken1 =  this.edu_form.controls.monthstakenCtrl.value;
       this.monthTaken2=  this.edu_form.controls.monthstakenCtrl.value;
       
       
      }
   }
  }

}
